import { useState } from "react";
import type { FormEvent } from "react";

export type SubmitStatus = "idle" | "loading" | "success" | "error";

interface FormApiResponse {
  code?: string;
  message?: string;
  meta?: { message?: string; detail?: string };
}

const SUCCESS_MESSAGE = "Merci ! Votre demande a bien été envoyée.";

export function useFormSubmit(submitAddr: string) {
  const [status, setStatus] = useState<SubmitStatus>("idle");
  const [message, setMessage] = useState("");

  async function handleSubmit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    const form = event.currentTarget;
    const formData = new FormData(form);

    const honeypot = ((formData.get("website_alt") as string) ?? "").trim();
    if (honeypot) {
      setStatus("success");
      setMessage(SUCCESS_MESSAGE);
      form.reset();
      return;
    }

    const payload = new URLSearchParams();
    formData.forEach((value, key) => {
      if (key === "website_alt") return;
      payload.append(key, value as string);
    });

    setStatus("loading");
    setMessage("");

    try {
      const response = await fetch(submitAddr, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: payload.toString(),
      });
      const responseText = await response.text();

      let parsed: FormApiResponse | null = null;
      try {
        parsed = JSON.parse(responseText) as FormApiResponse;
      } catch {
        parsed = null;
      }

      const code = parsed?.code;
      const serverMsg =
        parsed?.meta?.message ||
        parsed?.message ||
        parsed?.meta?.detail ||
        responseText;

      if (response.ok && code === "OK") {
        setStatus("success");
        setMessage(SUCCESS_MESSAGE);
        form.reset();
      } else {
        setStatus("error");
        setMessage(
          typeof serverMsg === "string"
            ? serverMsg
            : "Une erreur est survenue. Veuillez réessayer."
        );
      }
    } catch {
      setStatus("error");
      setMessage("Une erreur réseau est survenue. Veuillez réessayer.");
    }
  }

  return { status, message, handleSubmit };
}